import axios from 'axios'
// import { getToken } from '@/utils/auth'
import store from '@/store'

const baseUrl = process.env.VUE_APP_APIURL

console.log(baseUrl)

// 创建axios实例
const service = axios.create({
  baseURL: baseUrl,
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['Authorization'] = 'Bearer' + ' ' + store.getters.token // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  response => {
    const data = response.data
    const status = response.status
    console.log(response.data)
    if (status === 200 || status === 201) {
      // 正常请求返回。登录返回的有access_token， 普通情况返回有status
      if (data.status === 0) {
        return data
      } else if (data.status === 40010 || data.status === 40008) {
        store.dispatch('LogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      } else if (data.status !== 0 || data.access_token !== null) {
        return data
      } else {
        return Promise.reject('error')
      }
    } else {
      return Promise.reject('error')
    }
  },
  error => {
    console.log('err ' + error.response) // for debug
    if (error.response.status === 401) {
      console.log('401 error')
    }
    return Promise.reject(error)
  }
)

export default service
